import { motion } from "framer-motion";

const Reveal = ({ children, delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 70 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.8,
        ease: "easeOut",
        delay: delay,
      }}
      viewport={{ once: true, amount: 0.2 }}
      style={{ width: "100%" }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;

